import './Sobre.css';
import sobre1 from '../../img/sobre1.png';
import sobre2 from '../../img/sobre2.png';
import sobre3 from '../../img/sobre3.png';
import React, { useEffect } from 'react';

function Sobre() {

    useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fade-in");
            }
        });
    }, { threshold: 0.1 });

    // Observando o título, os textos e as imagens
    document.querySelectorAll(".title, .container-1 p, .container-img1 img, .container-img2 img").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
}, []);

    return (
        <div className="container-inicial container-sobre" id='sobre'>
            <div className="containers">
                <div className='container-1'>
                    <h1 className='title'>Sobre nós</h1>
                    <p>A Blue Análises e Serviços Ambientais, localizada em Juiz de Fora, é referência em soluções ambientais integradas. Nossa missão é oferecer suporte técnico especializado para empresas privadas, setor público e indústrias que buscam atuar de forma sustentável e em conformidade com as regulamentações ambientais.</p>
                    <p><span className='sub-title'>Missão: </span>Oferecer soluções ambientais integradas nas áreas de licenciamento, gestão de resíduos, educação e análises ambientais. Nosso compromisso é apoiar empresas privadas, o setor público e a indústria na construção de um desenvolvimento verdadeiramente sustentável, com atendimento personalizado e excelência técnica.</p>
                    <p><span className='sub-title'>Visão: </span>Custo-benefício e excelência; Compromisso com ética e transparência; Equipe altamente qualificada; Atendimento personalizado; Tecnologia e inovação; Trabalho justo e responsável.</p>
                    <p><span className='sub-title'>Valores: </span>Sustentabilidade; Excelência; Técnica; Atendimento Personalizado; Ética e Responsabilidade; Educação Ambienta; Inovação Contínua.</p>
                </div>
                <div className='container-2'>
                    <div className='container-img1'>
                        <img src={sobre1} alt="Imagem ilustrativa" />
                        <img className='img-992' src={sobre2} alt="Imagem ilustrativa" />
                        <img className='img-992' src={sobre3} alt="Imagem ilustrativa" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sobre;